<div class="drag-drop-filter-container">
	<div [ngClass]="containerClass">
		<input class="drag-drop-filter" type="text" [(ngModel)]="filter"
			(ngModelChange)="onFilterChange()" placeholder="Recherche" />
	</div>
	<div [ngClass]="containerClass">&nbsp;</div>
</div>

<div>
	<div [ngClass]="[containerClass, 'drag-drop-container']">
		<h2>{{leftTitle}}</h2>

		<div cdkDropList cdkDropListSortingDisabled
			#leftListElement="cdkDropList" [cdkDropListData]="retainedLeftList"
			[cdkDropListConnectedTo]="[rightListElement]"
			[ngClass]="[listClass, 'drag-drop-list', 'drag-list']"
			(cdkDropListDropped)="dropLeft($event)">
			<div class="drag-drop-box" *ngFor="let item of retainedLeftList"
				cdkDrag [cdkDragPreviewContainer]="parentContainer">
				{{getLabel(item)}}</div>
		</div>
	</div>

	<div [ngClass]="[containerClass, 'drag-drop-container', 'drop-container']">
		<h2>{{rightTitle}}</h2>

		<div cdkDropList cdkDropListSortingDisabled
			#rightListElement="cdkDropList" [cdkDropListData]="rightList"
			[cdkDropListConnectedTo]="[leftListElement]"
			[ngClass]="[listClass, 'drag-drop-list', 'drop-list']"
			(cdkDropListDropped)="dropRight($event)">
			<div class="drag-drop-box" *ngFor="let item of rightList" cdkDrag
				[cdkDragPreviewContainer]="parentContainer">
				{{getLabel(item)}}</div>
		</div>
	</div>
</div>